$(document).foundation();


// 
$(document).ready(
	$('#inquiry-form').on("open.zf.reveal", function() {	
		var $frame = $('#inquiry-form-frame').children("iframe");
		$($frame).attr("src", $frame.data("src"));
	})
);

var sja = {
	
	// Function to trigger appearance of elements when scroll point is reached
	// $selector is any jquery valid selector, $triggerPoint is scroll position in pixels, $activeClass is class to apply to selected element to change appearance
	scrollTrigger: function($selector,$triggerPoint,$activeClass) {
	    $(window).scroll(function() {
		
			var $btn = $($selector);
	
			if($(document).scrollTop() > $triggerPoint) {
				if(!$btn.hasClass($activeClass)) {
					$btn.addClass($activeClass);
		        }
	        }
	        else {		        
				if($(':root').hasClass('is-reveal-open')) {
						$btn.addClass($activeClass);
						console.log("is open");
			        
			    }
				else {
					if($btn.hasClass($activeClass)) {
						$btn.removeClass($activeClass);		
					}
				}  
			}
		})
	}
};

// Initiate menu listener
$(document).ready(
	$('.site-nav-toggle').on('click', function() {
		$(this).toggleClass("active");
	})
);


// Initiate sticky button and site header to appear on scroll
$(document).ready(
	sja.scrollTrigger('.js-sticky-button',100,'active'),
	sja.scrollTrigger('.site-header-container',100,'small'),
	AOS.init({
		offset: 150,
		delay: 500,
		duration: 1000,
		easing: 'ease-in-out',
		mirror: false,
		once: true})
);

// Initiate slick sliders
$(document).ready(function() {	
	
	// Show text animation on first slide at init
	$('.hero-slider').on('init', function(event, slick) {
		var thisSlide = slick.$slides[0];
		console.log(thisSlide);
		setTimeout(function(){$(thisSlide).find('h1').addClass('ani-active')},1000);
		/*$(slick.$slides).not(thisSlide).find('h1').removeClass('ani-active');*/
	});
	
	// Show text animation for subsequent slides upon slide change
	$('.hero-slider').on('afterChange', function(event, slick, currentSlide){
		var thisSlide = slick.$slides[currentSlide];
		$(thisSlide).find('h1').delay(250).addClass('ani-active');
		$(slick.$slides).not(slick.$slides[currentSlide]).find('h1').removeClass('ani-active');
	});
	
	// Initiate sliders in hero blocks	
	$('.hero-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		arrows: false,
		fade: true,
		speed: 1000,
		pauseOnHover: false
	});

	
	// Initiate sliders inside modals when modal is opened
	$('.reveal').on("open.zf.reveal", function() {
		var $id = $(this).attr('id');
		var $selector = '#' + $id + ' .Sirv';
		console.log($selector);
		Sirv.start($selector);
		//Sirv.start('.Sirv');
		$(this).find('.reveal-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			lazyLoad: 'ondemand'
		});
	});
	
	// Destroy sliders inside modals when modals are closed	
	/*$('.reveal').on("closed.zf.reveal", function(e) {
		$(this).find('.reveal-slider').slick('unslick');
		console.log(e.currentTarget);
	}); */
	
	
	// Load range map when modal is opened
	$('#range-map').on("open.zf.reveal", function() {
		$('#range-map-iframe').attr('src', 'https://syberjet.com/tools/range-map');
	});

	//var elem = new Foundation.Reveal(element, options);


});

// https://css-tricks.com/animating-number-counters/



/*function animateValue(obj, start, end, duration) {
	
/*function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
	
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerHTML = Math.floor(progress * (end - start) + start);
    if (progress < 1) {
	  //var fonum = formatNumber(step)
      window.requestAnimationFrame(step);
    }
  };
  //var fonum = formatNumber(step)
  window.requestAnimationFrame(step);
}

var obj = document.getElementById("js-speed-value");
animateValue(obj, 250, 528, 5000);


obj = document.getElementById("js-range-value");
animateValue(obj, 2000, 2500, 5000);*/


	
	
		

               	
	
		
	/*$('[id="inquiry-form"]').on("open.zf.reveal", function() {
		$.ajax({
			url: "https://form.jotform.com/jsform/210126130175036",
			dataType: "script"
		});
	});*/
	
	
	/*function formInit() {
		var $inquiryForm = $('[id="inquiry-form"]');
		var elem = new Reveal($inquiryForm);

	}
	
	setTimeout(formInit, 10000);*/
	
	
    $(function () {
	    $(".specs-toggle").click(function () {
	        var tog = $(this).attr("data-group");
	        $("#" + tog).toggleClass("display");
	        $(this).toggleClass("active");
        });
    });
    
    
    
    
   


	/*$('#no-js-site-nav-toggle').click(function() {
		if($('#no-js-site-nav-toggle').prop('checked')) {
			$('main').addClass('blur');
		}
		else {
			$('main').removeClass('blur');
		}
	});*/